import { WorkflowIconService } from 'app/services/workflow-icon.service';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { trigger, state, style, animate, transition, AUTO_STYLE } from '@angular/animations';

const animationTime = 175;

@Component({
    selector: 'workflow-card',
    templateUrl: './workflow-card.component.html',
    styleUrls: ['./workflow-card.component.scss'],
    animations: [
        trigger('_closed', [
            state('false', style({
                height: AUTO_STYLE,
            })),
            state('true', style({
                height: 0,
            })),
            transition('false <=> true', [animate(animationTime)]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WorkflowCardComponent implements OnInit, OnChanges {
  @ViewChild('childrenContainer')
  childrenContainer: ElementRef;

  @Input() status: string;
  @Input() order: string;
  @Input() title: string;
  @Input() taskCount: number;
  @Input() tasksComplete = -1;
  @Input() description: string;
  @Input() nocontent = false;
  @Input() bottomCardPadding = false;

  iconProperties = {
    iconPath: '',
    className: '',
  };

  _childrenCollapsedState = {
    closed: true,
    iconPath: 'dropdown',
    label: 'Expand',
  };

  changeExpandState() {
    this._childrenCollapsedState.closed = !this._childrenCollapsedState.closed;

    if (this._childrenCollapsedState.closed) {
      this._childrenCollapsedState.iconPath = 'dropdown';
      this._childrenCollapsedState.label = 'Expand';
    } else {
      this._childrenCollapsedState.iconPath = 'dropup';
      this._childrenCollapsedState.label = 'Collapse';
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private workflowIconService: WorkflowIconService) {}

  ngOnInit() {
    this.iconProperties = this.workflowIconService.changeIcon(this.status, 'card');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.status) {
      this.iconProperties = this.workflowIconService.changeIcon(changes.status.currentValue, 'card');
    }
  }

  // eslint-disable-next-line
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }
}